// Fires a GA4/GTM "virtual pageview" for SPA client-side navigations (quiz steps,
// paywall, checkout). These are pushState routes: the GTM container loads only
// once, so GA4 keeps the page_location it captured on that
// first load. A virtual pageview MUST therefore send the full page_location (and
// page_title) — otherwise every step collapses onto the entry URL and the funnel
// report goes flat. Callers pass an absolute path (e.g. `/quiz/x/q3`); we build
// page_location from the current origin.
//
// GTM side: a Custom Event trigger on `virtual_page_view` must feed a GA4 Event
// tag (event_name = page_view) that overrides page_location/page_path/page_title
// from these dataLayer values — otherwise the event fires but no page_view is
// recorded.
export function trackVirtualPageview(path: string, extra: Record<string, any> = {}): void {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'virtual_page_view',
            page_path: path,
            page_location: window.location.origin + path,
            page_title: document.title,
            ...extra,
        });
    } catch {
        // analytics must never break the funnel
    }
}

export default trackVirtualPageview;
